export default "__VITE_ASSET__C3OLoXKJ__"